import { call, put, takeEvery } from 'redux-saga/effects';
import { gcApi } from '../config/axios';

import {
    FETCH_BIOMETRIC_POWER_ZONES,
    FETCH_BIOMETRIC_POWER_ZONES_SUCCESS,
    FETCH_BIOMETRIC_POWER_ZONES_FAIL
} from '../actions/ActionTypes';

export function* fetchPowerZonesSaga(action) {
    try {
        let response;
        //by default the api generate ftp
        if (action.doNotGenerateDefaults) {
            response = yield call(gcApi.get, `/biometric-service/powerZones/sports/all?generateDefaults=false`);
        } else {
            response = yield call(gcApi.get, `/biometric-service/powerZones/sports/all`);
        }

        yield put({
            type: FETCH_BIOMETRIC_POWER_ZONES_SUCCESS,
            powerZones: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_BIOMETRIC_POWER_ZONES_FAIL,
            powerZones: {}
        });
    }
}

export const powerZonesSagas = [takeEvery(FETCH_BIOMETRIC_POWER_ZONES, fetchPowerZonesSaga)];
